var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[(_vm.status === 'auth')?_c('Auth'):_vm._e(),(_vm.status === 'main')?_c('Main'):_vm._e(),(_vm.status === 'maintenance')?_c('Maintenance'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }